<template >
<div>

  <!-- Componente de Filtros -->
  <filtros-gestion @filtrar="aplicarFiltros" @limpiar="limpiarFiltros"></filtros-gestion>

  <!-- Mensaje informativo cuando no hay filtros aplicados -->
  <v-alert v-if="!filtrosAplicados" type="info" text class="mb-4">
    <v-icon left>mdi-information</v-icon>
    Por favor, aplique filtros para buscar sus solicitudes asignadas.
  </v-alert>

  <v-data-table
    :headers="headers"
    :items="items"
    :search="search"
    class="elevation-1"
  >

    <template  v-slot:top >
      <v-toolbar flat color="white">
        <gestion-desarchivo-form   :itemIndex="itemIndex"  :inputItem="editedItem" :actionItem="actionOnItem" ></gestion-desarchivo-form>
        <v-spacer></v-spacer>
        </v-toolbar>
    </template>

    <template v-slot:item.estado_solicitud="{ item }">

        <estado-solicitud :inputItem="item" ></estado-solicitud>

    </template>

    <template v-slot:item.estado_desarchivo="{ item }">

        <estado-desarchivo :inputItem="item" ></estado-desarchivo>

    </template>

    <template v-slot:item.action="{ item }">

        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-icon
                    small
                    @click="verItem(item)"
                    v-on="on"
                >
                    mdi-eye
                </v-icon>
            </template>
            <span>Detalles</span>
        </v-tooltip>

        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                    v-on="on"
                >
                    mdi-pencil
                </v-icon>
            </template>
            <span>Editar</span>
        </v-tooltip>

        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-icon
                    small
                    @click="comentarItem(item)"
                    v-on="on"
                >
                    mdi-chat
                </v-icon>
            </template>
            <span>Comentarios</span>
        </v-tooltip>

    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="fetchSolicitudDesarchivo">Recargar</v-btn>
    </template>
  </v-data-table>

    <detalles :inputItem="detallesItem.id" ></detalles>
    <comentarios :inputItem="detallesItemC" ></comentarios>


</div>

</template>

<script>

import GestionDesarchivoForm from "./GestionDesarchivoForm"
import Detalles from "./Detalles"
import Comentarios from "../Comentarios/ComentariosList"
import EstadoSolicitud from "./EstadoSolicitud"
import EstadoDesarchivo from "./EstadoDesarchivo"
import FiltrosGestion from "./FiltrosGestion"
import { EventBus } from "../../EventBus"

  export default {

    components:{
        'gestion-desarchivo-form':GestionDesarchivoForm,
        'detalles':Detalles,
        'comentarios':Comentarios,
        'estado-solicitud':EstadoSolicitud,
        'estado-desarchivo':EstadoDesarchivo,
        'filtros-gestion':FiltrosGestion
    },

    data: () => ({

      items:[],
      search: '',
      openForm: false,
      tipo: '',
      buscar: '',
      filtrosAplicados: false,
      filtrosActuales: {},

      headers: [

        { text: 'Nro. Solicitud', value: 'id' },
        { text: 'Estado Solicitud', value: 'estado_solicitud' },
        { text: 'Estado Desarchivo', value: 'estado_desarchivo' },
        { text: 'Radicado', value: 'radicado' },
        { text: 'Acciones', value: 'action', sortable: false }
      ],
      itemIndex: -1,
      actionOnItem:'',
      editedItem: {},
      detallesItem: {},
      detallesItemC: {}
    }),

    created(){
       // No cargar datos automáticamente
    },
    mounted(){
      EventBus.$on("gestion_list_refresh", () => {
        if (this.filtrosAplicados) {
          this.fetchSolicitudDesarchivo(this.filtrosActuales);
        }
      });
    },
    beforeDestroy(){
      EventBus.$off("gestion_list_refresh");
    },
    computed: {

    },

    methods: {
      fetchSolicitudDesarchivo(filtros = {}){
         const params = new URLSearchParams();
         
         // Siempre agregar el filtro de gestor para esta vista
         params.append('consulta', 'gestor');
         
         // Agregar filtros adicionales
         Object.keys(filtros).forEach(key => {
           if (filtros[key] !== '' && filtros[key] !== null && filtros[key] !== undefined) {
             params.append(key, filtros[key]);
           }
         });

         axios.get('api/solicitud_desarchivo', { params })
              .then(response=>{
                  this.items=response.data.data
               })
              .catch((error)=>{
                    console.log(error);
                    this.$alertify.error("Error al cargar las solicitudes");
              })
       },
       aplicarFiltros(filtros) {
         this.filtrosActuales = filtros;
         this.filtrosAplicados = true;
         this.fetchSolicitudDesarchivo(filtros);
       },
       limpiarFiltros() {
         this.filtrosActuales = {};
         this.filtrosAplicados = false;
         this.items = [];
       },
       verItem(item){
           this.detallesItem = Object.assign({}, item);
       },
       comentarItem(item) {
           this.detallesItemC = Object.assign({}, item);
        },
         editItem (item) {
          this.actionOnItem='edit';
          this.itemIndex = this.items.indexOf(item);
          this.editedItem = Object.assign({}, item);
          this.openForm=true;
        },
    }
  }
</script>
